import { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import {
	adjustDateFormat,
	convertTimeIntoSeconds,
} from "../../../helperFunctions/utils";
import { resetValue, setData } from "../../../redux/slices/StaffFormsSlices";

import _ from "lodash";

import { SearchIcon } from "../../../assets/images/index";
import Schedular from "./Schedular";
import ComponentWrapepr from "../../SharedComponents/ComponentWrapper";
import { permissionTypes } from "../../../helperFunctions/routes";
import DateInput from "../../SharedComponents/DateInput";
import { getSetting } from "../../../apis/generalSetting";
import { getActiveStaffByDate } from "../../../apis/activeStaff";
import moment from "moment";

export default function Rostering() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const [refreshAppointments, setRefreshAppointments] = useState(false);
	const {
		// bucketList,
		currentDate,
		appointmentsForRostering,
		waitingListForRostering,
		rosteringCardData,
	} = useSelector((state) => state.staffForm);
	const [bucketList, setBucketList] = useState(
		location?.state?.bucketList || [],
	);
	const [staff, setStaff] = useState(
		bucketList
			.filter((o) => o?.staff?.id)
			?.map((o) => {
				return { ...o.staff, isSelected: false };
			}),
	);
	const [filteredAppointments, setFilteredAppointments] = useState([]);
	const [filteredWaitingList, setFilteredWaitingList] = useState([]);
	const [filteredStaff, setFilteredStaff] = useState(staff);
	const [showSuggestion, setShowSuggestions] = useState();
	const [search, setSearch] = useState();
	const [loading, setLoading] = useState(false);
	const [appointmentsForSchedule, setAppointmentForSchedule] = useState([]);
	const [sessionList, setSessionList] = useState([]);
	const [billingList, setBillingList] = useState([]);
	const [statusRostering, setStatusRostering] = useState({});
	const [rosteringDate, setRosteringDate] = useState(currentDate);
	const [holidayDates, setHolidayDates] = useState([]);
	const [descHoliday, setDescHoliday] = useState("");

	const getListOfHolidays = async () => {
		const { result, error } = await authorizedRequests({
			url: "holidays/listOfHolidays",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "", "error");
			return;
		}
		const dates = result.data?.map((d) => { return { date: moment(d.eventDate), name: d.description } })
		setHolidayDates(dates)
	}

	useEffect(() => {
		getListOfHolidays()
	}, []);

	useEffect(() => {
		console.log(rosteringDate)
		if (holidayDates?.length !== 0) {
			const momentDay = moment(rosteringDate);
			const dates = holidayDates?.find(disabledDate =>
				disabledDate?.date.day() === momentDay.day()
				&& disabledDate?.date.month() === momentDay.month()
				&& disabledDate?.date.year() === momentDay.year()
			);

			if (dates) {
				setDescHoliday(`${momentDay.format("DD/MMMM/YYYY")} is a ${dates?.name}`);
			} else {
				setDescHoliday("");
			}
		} else {
			setDescHoliday("");
		}
	}, [rosteringDate, holidayDates])

	const timeSlots = [
		"00:00",
		"00:30",
		"01:00",
		"01:30",
		"02:00",
		"02:30",
		"03:00",
		"03:30",
		"04:00",
		"04:30",
		"05:00",
		"05:30",
		"06:00",
		"06:30",
		"07:00",
		"07:30",
		"08:00",
		"08:30",
		"09:00",
		"09:30",
		"10:00",
		"10:30",
		"11:00",
		"12:30",
		"12:30",
		"13:00",
		"13:30",
		"14:00",
		"14:30",
		"15:00",
		"15:30",
		"16:00",
		"16:30",
		"17:00",
		"17:30",
		"18:00",
		"18:30",
		"19:00",
		"19:30",
		"20:00",
		"20:30",
		"21:00",
		"21:30",
		"22:00",
		"22:30",
		"23:00",
		"23:30",
	];
	const [locations, setLocations] = useState([
		...bucketList.map((item) => {
			return {
				location: item.location,
				text: item.location,
				id: item.id,
			};
		}),
	]);
	let tempLocationsArr = [...locations];
	tempLocationsArr = _.uniqWith(tempLocationsArr, _.isEqual);
	tempLocationsArr.push({
		text: "Waiting List",
		id: 0,
	});
	// if (bucketList?.length === 0) {
	// 	navigate(-1);
	// }
	useEffect(() => {
		if (location?.state?.bucketList?.length > 0) {
			dispatch(
				setData({
					parent: "bucketList",
					value: location?.state?.bucketList,
				}),
			);
		}
	}, [location?.state?.bucketList, locations]);

	useEffect(() => {
		getSetting()
			.then((res) => {
				setStatusRostering(res?.statusRostering);
			})
	}, []);

	useEffect(() => {
		authorizedRequests({
			url: "session/listOfSession",
			method: "get",
			params: {
				date: rosteringDate
			}
		}).then((res) => {
			setSessionList(res?.result?.data);
		});
	}, [rosteringDate]);

	useEffect(() => {
		authorizedRequests({
			url: "payment/listOfPayments",
			method: "get",
			params: {
				date: rosteringDate
			}
		}).then((res) => {
			setBillingList(res?.result?.data);
		});
	}, [rosteringDate])

	function AddOrSubractDays(startingDate, number, add) {
		if (add) {
			return new Date(
				startingDate.getFullYear(),
				startingDate.getMonth(),
				startingDate.getDate() + 1,
			);
		} else {
			return new Date(
				startingDate.getFullYear(),
				startingDate.getMonth(),
				startingDate.getDate() - 1,
			);
		}
	}
	useEffect(() => {
		let tempStaff = [...filteredStaff.filter((o) => o.isSelected)];
		tempStaff = tempStaff.length > 0 ? tempStaff : filteredStaff;
		var tempArr = filteredAppointments.filter((o, i) => {
			const containsStaff = o.allStaff.find((staff) => {
				if (tempStaff.find((k) => k.id == staff.staff.id)) {
					return true;
				}
			});
			if (
				filteredAppointments.findIndex(
					(k, idx) => k._id == o._id && idx > i,
				) == -1 &&
				containsStaff
			) {
				return true;
			}
		});

		dispatch(
			setData({
				parent: "rosteringCardData",
				value: [...tempArr, ...filteredWaitingList],
			}),
		);
		tempArr = tempArr.map((o) => {
			const s_time = o.startTime.split(":");
			const s_h = s_time[0] < 10 ? `${0 + s_time[0]}` : s_time[0];
			const s_m = s_time[1] < 10 ? `${0 + s_time[1]}` : s_time[1];

			const e_time = o.endTime.split(":");
			const e_h = e_time[0] < 10 ? `${0 + e_time[0]}` : e_time[0];
			const e_m = e_time[1] < 10 ? `${0 + e_time[1]}` : e_time[1];

			return {
				id: o._id,
				locationId: o.location,
				startDate: new Date(new Date(o.date).setHours(s_h, s_m)),
				endDate: new Date(new Date(o.date).setHours(e_h, e_m)),
				color: o?.tag[0]?.color ? o?.tag[0]?.color : "#E4DDFC",
				status: o?.status,
			};
		});

		const tempArr2 = filteredWaitingList.map((o) => {
			const s_time = o.startTime.split(":");
			const s_h = s_time[0] < 10 ? `${0 + s_time[0]}` : s_time[0];
			const s_m = s_time[1] < 10 ? `${0 + s_time[1]}` : s_time[1];

			const e_time = o.endTime.split(":");
			const e_h = e_time[0] < 10 ? `${0 + e_time[0]}` : e_time[0];
			const e_m = e_time[1] < 10 ? `${0 + e_time[1]}` : e_time[1];
			return {
				id: o._id,
				gender: o.gender,
				remarks: o.remarks,
				date: o.date,
				startDate: new Date(new Date(o.date).setHours(s_h, s_m)),
				endDate: new Date(new Date(o.date).setHours(e_h, e_m)),
				locationId: 0,
				color: "#E4DDFC",
			};
		});
		const newArr = [...tempArr, ...tempArr2];
		setAppointmentForSchedule(newArr);
	}, [filteredAppointments, filteredWaitingList, filteredStaff]);
	useEffect(() => {
		(async () => {
			const { result, error } = await authorizedRequests({
				url: "waitingList/listOfWaitings",
				method: "get",
			});
			if (error) {
				toastify(
					error.message ?? "Failed to get waiting list",
					"error",
				);
				return;
			}

			const tempArr = result.data.map((o) => {
				return {
					patientName: o.patientName,
					_id: o._id,
					remarks: o.remarks,
					gender: o.gender,
					startTime: o.startTime,
					endTime: o.endTime,
					date: o?.date,
				};
			});
			dispatch(
				setData({
					parent: "waitingListForRostering",
					value: tempArr,
				}),
			);
		})();
	}, [refreshAppointments]);

	const getAppointmentForRostering = async () => {
		const { result, error } = await authorizedRequests({
			url: "appointment/listOfAppointments",
			method: "get",
		});
		if (error) {
			toastify(
				error.message ?? "Failed to get appointments list",
				"error",
			);
			return;
		}
		let tempArr = result.data
			?.filter((app) => app.status !== "Not Show")
			// .filter((item) => {
			// 	return bucketList.find((o) => o.id === item.location);
			// })
			.map((item) => {
				const temp = bucketList?.filter((o) => {
					return item?.staff?.find(
						(staff) => staff?._id === o?.staff?.id,
					);
				});
				// const temp = item.staff.filter((o) => {
				// 	return bucketList.find((buc) => buc.staff.id === o._id);
				// });

				if (temp.length > 0) {
					return temp.map((k) => {
						return {
							...item,
							staff: k.staff,
							allStaff: temp,
							completeStaffList: item.staff,
						};
					});
				}
			});
		tempArr = _.flattenDeep(tempArr);
		tempArr.sort((a, b) => {
			if (a["startTime"] > b["startTime"]) {
				return 1;
			}
			if (a["startTime"] < b["startTime"]) {
				return -1;
			}
			return 0;
		});
		dispatch(
			setData({
				parent: "appointmentsForRostering",
				value: [...tempArr.filter((o) => o)],
			}),
		);
	}

	useEffect(() => {
		if (locations?.length) {
			getAppointmentForRostering()
		}
	}, [locations, refreshAppointments]);

	const getActiveStaff = async () => {
		const { result, error } = await getActiveStaffByDate({
			date: currentDate,
		});
		if (error) {
			toastify(error.message, "error");
		} else {
			const activeStaff = result?.data?.staff;
			const newBucketList = activeStaff?.map((newStaff) => {
				return {
					id: newStaff.location,
					location: newStaff.locationName,
					staff: {
						department: newStaff.department?.name,
						id: newStaff._id,
						isChecked: true,
						name: newStaff.username
					}
				}
			});

			setBucketList(newBucketList ? newBucketList : []);
			const newFilteredStaff = newBucketList
				.filter((o) => o?.staff?.id)
				?.map((o) => {
					return { ...o.staff, isSelected: false };
				});
			setStaff(newFilteredStaff);
			setFilteredStaff(newFilteredStaff);
		}
	};

	useEffect(() => {
		setLoading(true);
		if (currentDate) {
			const tempArr = appointmentsForRostering?.filter((o) => {
				return (
					new Date(currentDate).toLocaleDateString() ==
					new Date(o?.date).toLocaleDateString()
				);
			});
			setFilteredAppointments(tempArr);
		}
	}, [currentDate, appointmentsForRostering]);

	useEffect(() => {
		if (currentDate) {
			const tempArr = waitingListForRostering?.filter(
				(o) =>
					new Date(currentDate).toLocaleDateString() ==
					new Date(o?.date).toLocaleDateString(),
			);
			setFilteredWaitingList(tempArr);
		}
	}, [currentDate, waitingListForRostering]);

	useEffect(() => {
		getActiveStaff();
	}, [currentDate]);

	return (
		<>
			<div className="container px-0 py-0">
				<div className="mainHeading w-100">
					<div
						className="datesButton d-flex bg-theme"
						style={{ borderRadius: "10px" }}
					>
						<Button
							className="  white-600-24 bg-theme border-0"
							style={{ fontWeight: 400 }}
							onClick={() => {
								let currDate = currentDate;

								const previousDate = AddOrSubractDays(
									new Date(currDate),
									1,
									false,
								);
								setRosteringDate(previousDate);
								dispatch(
									setData({
										parent: "currentDate",
										value: adjustDateFormat(previousDate),
									}),
								);
							}}
						>
							{"<"}
						</Button>
						<div className="date align-self-center white px-2 ">
							<div style={{ width: "150px", height: "45px" }}>
								<DateInput
									background={"#34556f"}
									calenderClass={"whiteCalender"}
									inputClassName="themeInput"
									value={currentDate}
									shouldDisableDates={true}
									onChange={(e) => {
										setRosteringDate(e);
										dispatch(
											setData({
												parent: "currentDate",
												value: e,
											}),
										);
									}}
								/>
							</div>
						</div>
						<Button
							className="white-600-24 bg-theme border-0"
							style={{ fontWeight: 400 }}
							onClick={() => {
								const nextDate = AddOrSubractDays(
									new Date(currentDate),
									1,
									true,
								);
								setRosteringDate(nextDate);
								dispatch(
									setData({
										parent: "currentDate",
										value: adjustDateFormat(nextDate),
									}),
								);
							}}
						>
							{">"}
						</Button>
					</div>
					<div className="d-flex">
						{
							descHoliday !== "" && (
								<div style={{
									padding: "10px",
									backgroundColor: "#f1c40f",
									color: "white",
									borderRadius: "10px",
									marginRight: "20px",
									height: "40px"
								}}>
									{descHoliday}
								</div>
							)
						}
						<Button
							className="addItem"
							style={{
								height: "55px",
							}}
							onClick={() => {
								navigate("/rostering", {
									state: {
										showBucket: true,
										isFromRostering: true,
									},
								});
							}}
						>
							Readjust Active Staff
						</Button>
						<ComponentWrapepr
							moduleName="Appointment"
							permissionType={permissionTypes.CREATE}
						>
							<Button
								className="addItem ms-2"
								style={{
									height: "55px",
								}}
								onClick={() => {
									dispatch(resetValue("appointmentForm"));
									navigate("/add-appointment");
								}}
							>
								+ New Appointment
							</Button>
						</ComponentWrapepr>
						<ComponentWrapepr
							moduleName="Appointment"
							permissionType={permissionTypes.CREATE}
						>
							<Button
								className="addItem ms-2"
								style={{
									height: "55px",
								}}
								onClick={() => {
									dispatch(resetValue("waitingListForm"));
									navigate("/add-waiting");
								}}
							>
								+ New Waiting List
							</Button>
						</ComponentWrapepr>
					</div>
				</div>
				<div className="roasting-view-table d-flex">
					<div className="name-column">
						<Form.Group
							className="position-relative"
							style={{ width: "250px" }}
						>
							<InputGroup
								className="p-0 search-group"
								style={{ borderRadius: 0 }}
								onClick={() => {
									setShowSuggestions(!showSuggestion);
								}}
							>
								<Form.Control
									placeholder="Search People"
									value={search}
									onChange={(e) => {
										setSearch(e.target.value);
										var tempArr = [...staff];
										tempArr = tempArr.filter((o) => {
											return o?.name?.includes(
												e?.target?.value,
											);
										});
										setFilteredStaff(tempArr);
										if (!e.target.value) {
											setFilteredStaff(staff);
										}
									}}
								/>
								<Button style={{ borderRadius: 0 }}>
									<img src={SearchIcon} />
								</Button>
							</InputGroup>

							{/* {showSuggestion && (
								
							)} */}
						</Form.Group>
						{filteredStaff?.length > 0 &&
							filteredStaff?.map((o, i) => {
								return (
									<div
										className="manual-column pointer"
										key={i}
										style={{
											background: `${o.isSelected
												? "#E9E9E9"
												: "white"
												}`,
										}}
										onClick={() => {
											let tempArr = [...staff];
											tempArr = tempArr.map((e) => {
												if (e.id == o.id) {
													return {
														...e,
														isSelected:
															!e.isSelected,
													};
												}
												return e;
											});
											setStaff(tempArr);
											setSearch("");
											setFilteredStaff(tempArr);
										}}
									>
										<div
											className="font-500-20"
											style={{ fontSize: "18px" }}
										>
											{o?.name}
										</div>
										<div className="grey">
											{o?.department}
										</div>
									</div>
								);
							})}
					</div>

					<div>
						<Schedular
							data={appointmentsForSchedule}
							statusRostering={statusRostering}
							sessionList={sessionList}
							billingList={billingList}
							setRefreshAppointments={setRefreshAppointments}
							locations={tempLocationsArr}
							loading={loading}
							setLoading={setLoading}
							currentDate={new Date(currentDate)}
							allData={[
								...rosteringCardData?.map((o, i) => {
									const col = (o?.tag && o?.tag?.length) ? o?.tag[0]?.color : "#E4DDFC";
									return {
										...o,
										color: col,
									};
								}),
							]}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
